import { Stack } from "expo-router";
import { observer } from "mobx-react";
import React from "react";
import { Header } from "~/components/Header";
import { Layout } from "~/components/Layout";
import { Screen } from "~/components/Screen";
import { BookAppointmentContainer } from "~/features/book-appointment/BookAppointmentContainer";

const AppLayout = observer(function AppLayout() {
  return (
    <Screen withBottomInset withTopInset preventScroll>
      <Layout
        cardStyle={{
          borderTopRightRadius: 2,
          borderTopLeftRadius: 2,
          borderBottomLeftRadius: 24,
          borderBottomRightRadius: 24,
        }}
      >
        <BookAppointmentContainer
          title={intl.formatMessage({
            id: "gOPXE6",
            defaultMessage: "Book Clinic Visit",
            description: "Title for booking a clinic visit",
          })}
        >
          <Stack
            initialRouteName="index"
            screenOptions={{
              header: (props) => <Header {...props} />,
              freezeOnBlur: false,
              animation: "slide_from_right",
            }}
          >
            <Stack.Screen
              name="index"
              options={{
                headerShown: false,
              }}
            />
            <Stack.Screen
              name="search-clinic"
              options={{
                headerShown: false,
              }}
            />
            <Stack.Screen
              name="appointment-type"
              options={{
                headerShown: false,
              }}
            />
            <Stack.Screen
              name="pet"
              options={{
                headerShown: false,
              }}
            />

            <Stack.Screen
              name="add-new-pet"
              options={{
                headerShown: false,
              }}
            />

            <Stack.Screen
              name="date-and-time"
              options={{
                headerShown: false,
              }}
            />

            <Stack.Screen
              name="notes"
              options={{
                headerShown: false,
              }}
            />
            <Stack.Screen
              name="add-client-details"
              options={{
                headerShown: false,
              }}
            />
            <Stack.Screen
              name="overview"
              options={{
                headerShown: false,
              }}
            />
            <Stack.Screen
              name="success"
              options={{
                headerShown: false,
              }}
            />
            <Stack.Screen
              name="edit-contact-details"
              options={{
                headerShown: false,
              }}
            />
          </Stack>
        </BookAppointmentContainer>
      </Layout>
    </Screen>
  );
});

export default AppLayout;
